import { Show, useForm } from "@refinedev/antd";
import { useNavigation } from "@refinedev/core";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Switch,
} from "antd";
import { useMatch } from "react-router-dom";

import { AppTitle } from "../../../components";
import {
  SLUG_PATTERN,
  TV_LEAGUES,
  TvCollection,
  tvErrorNotification,
  tvSuccessNotification,
} from "../Lib";
import { TvDelete } from "../Components";
import { CollectionItems } from "./CollectionItems";

export const TvCollectionShow = () => {
  const route = useMatch("/tv/collections/:id");
  const id = Number(route?.params.id) || undefined;
  const { push } = useNavigation();

  const { formProps, queryResult, formLoading } = useForm<TvCollection>({
    resource: "tv-collections",
    dataProviderName: "tvDataProvider",
    action: id ? "edit" : "create",
    id,
    redirect: false,
    ...tvSuccessNotification(id ? "Подборка сохранена" : "Подборка добавлена"),
    ...tvErrorNotification(),
    onMutationSuccess: ({ data }) => {
      if (!id && data?.id) push(`/tv/collections/${data.id}`);
    },
  });
  const record = queryResult?.data?.data;

  return (
    <Show
      isLoading={formLoading}
      title={
        <AppTitle isLoading={formLoading} canGoBack>
          {id ? record?.title ?? "Подборка" : "Новая подборка"}
        </AppTitle>
      }
      breadcrumb={false}
      goBack={false}
      footerButtons={null}
      headerButtons={() =>
        id && record ? (
          <TvDelete
            resource="tv-collections"
            id={id}
            name={record.title}
            entityAccusative="подборку"
            redirectPath="/tv/collections"
            size="middle"
          />
        ) : null
      }
    >
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Form
          {...formProps}
          layout="vertical"
          initialValues={
            id
              ? formProps.initialValues
              : { isActive: true, sortOrder: 0, view: "CARDS" }
          }
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                name="title"
                label="Название"
                rules={[{ required: true, whitespace: true }, { max: 255 }]}
              >
                <Input placeholder="Камбэки сезона" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="slug"
                label="Адрес страницы"
                rules={[
                  { required: true, message: "Укажите адрес" },
                  {
                    pattern: SLUG_PATTERN,
                    message:
                      "Только латиница, цифры и дефис, от 2 до 128 символов",
                  },
                ]}
              >
                <Input addonBefore="/collection/" placeholder="kambeki" />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="leagueId"
                label="Лига"
                extra="Пусто — для всех лиг"
              >
                <Select
                  allowClear
                  options={TV_LEAGUES}
                  placeholder="Все лиги"
                />
              </Form.Item>
            </Col>
            <Col xs={12} md={8}>
              <Form.Item
                name="sortOrder"
                label="Порядок на главной"
                extra="Меньше — выше"
              >
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={12} md={8}>
              <Form.Item
                name="isActive"
                label="Показывать"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="view"
                label="Вид на сайте"
                extra="Промо-обложки — крупные картинки без подписи (как «Лучшее» в макете): заголовок и тур рисуются на обложке видео"
              >
                <Select
                  options={[
                    { value: "CARDS", label: "Обычные карточки с подписью" },
                    { value: "PROMO", label: "Промо-обложки" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Button type="primary" htmlType="submit" loading={formLoading}>
            {id ? "Сохранить" : "Добавить подборку"}
          </Button>
        </Form>
        {id && record && (
          <CollectionItems
            collectionId={id}
            videoIds={record.videoIds}
            onSaved={() => queryResult?.refetch()}
          />
        )}
      </Space>
    </Show>
  );
};
